import { Button, Flex, FormControl, FormErrorMessage } from "@chakra-ui/react";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormProvider, useForm } from "react-hook-form";
import z from "zod";
import SelectAdmin from "../inputs/SelectAdmin";

const ChangeModelerOrderFormSchema = z.object({
	userId: z.number(),
});
export type ChangeModelerOrderFormType = z.infer<
	typeof ChangeModelerOrderFormSchema
>;

type Props = {
	onSubmit?: (values: ChangeModelerOrderFormType) => void;
};

const ChangeModelerOrderForm = (props: Props) => {
	const methods = useForm({
		resolver: zodResolver(ChangeModelerOrderFormSchema),
	});

	const handleSubmit = async () => {
		const valid = await methods.trigger();
		if (valid) {
			if (props.onSubmit) {
				props.onSubmit(methods.getValues() as ChangeModelerOrderFormType);
			}
		}
	};

	return (
		<FormProvider {...methods}>
			<form style={{ marginTop: "32px", marginBottom: "32px" }}>
				<Flex direction="column" gap={4}>
					<FormControl isInvalid={!!methods.formState.errors.userId}>
						<SelectAdmin
							placeholder="Modeleur"
							user={methods.getValues("userId")}
							setUser={(user) => methods.setValue("userId", user?.id)}
						></SelectAdmin>
						<FormErrorMessage>
							<>{methods.formState.errors?.userId?.message}</>
						</FormErrorMessage>
					</FormControl>

					<Flex mt={3} pt={3} justifyContent={"end"} w="100%">
						<Button
							w={"100%"}
							onClick={handleSubmit}
							bgColor="brand.600"
							color="white"
						>
							Valider
						</Button>
					</Flex>
				</Flex>
			</form>
		</FormProvider>
	);
};

export default ChangeModelerOrderForm;
